import { ApolloProvider as HooksProvider } from '@apollo/client';
import React from 'react';
import client from './apolloClient';

const ApolloProvider = ({ children }) => {
  return <HooksProvider client={client}>{children}</HooksProvider>;
};

export default ApolloProvider;
